export default __webpack_public_path__ + "static/media/App-button-download.05358005.svg";